import React from 'react'
import PropTypes from 'prop-types';
// import clsx from 'clsx';
import axios from 'axios'
import { connect } from 'react-redux'
import { fade, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Chip from '@material-ui/core/Chip';
import AdbIcon from '@material-ui/icons/Adb';
import { Button, CircularProgress }  from '@material-ui/core';
import Grid from '@material-ui/core/Grid'
// import Toolbar from '@material-ui/core/Toolbar';
// import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
// import Checkbox from '@material-ui/core/Checkbox';
// import IconButton from '@material-ui/core/IconButton';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import AddIcon from '@material-ui/icons/AddCircle';
// import FilterListIcon from '@material-ui/icons/FilterList';
// import moment from 'moment'
import SignatureBox from './SignatureBox'
import LineItemDetails from './OnlineProposalLineItems'
import ESignatureModal from './ESignatureModal'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    justifyItems: 'center',
    backgroundColor: '#eee'
  },
  paper: {
    // width: '100%',
    marginTop: 10,
    marginBottom: theme.spacing(2),
    minHeight: '90vh',
    [theme.breakpoints.down('sm')]: {
      // backgroundColor: 'pink'
      width: '100%'
    },
    [theme.breakpoints.up('md')]: {
      minHeight: '50vh',
      maxWidth: 960,
      textAlign: 'center'
    },
    [theme.breakpoints.up('lg')]: {
      minHeight: '50vh',
      maxWidth: 1360,
      textAlign: 'center'
    },
    // margin: 20
  },
  sigBox: {
    // backgroundColor: 'green',
    margin: 20,
    width: '100%',
    textAlign: 'center'
  },
  headerImages: {
    marginTop: 5,
    width: '100%',
    overflow: 'hidden'
  },
  footerImages: {
    marginTop: 5,
    width: '100%',
    overflow: 'hidden'
  },
  disclosureArea: {
    fontSize: '0.8rem',
    color: '#bbb',
    textAlign: 'center'
  },
  headerText: {
    fontSize: 32,
    color: '#aaa',
    // color: 'rgb(119,156,164)',
    [theme.breakpoints.down('sm')]: {
      // backgroundColor: 'pink'
      // width: '100%'
      fontSize: 18,
      // color: 'red'
    },
    [theme.breakpoints.down('xs')]: {
      // backgroundColor: 'pink'
      // width: '100%'
      fontSize: 14,
      // color: 'pink'
    },
    [theme.breakpoints.up('md')]: {
      // minHeight: '50vh',
      // maxWidth: 1360,
      // textAlign: 'center'
      fontSize: 24,
      // color: 'green'
    }
  },
  headerLogo: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: '65%'
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: 300
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: '90%'
    }
  },
  giantText: {
    textAlign: 'center',
    fontSize: 48,
    fontFamily: 'Amiri',
    color: 'rgb(119,156,164)',
    marginBottom: -15
  },
  subText: {
    textAlign: 'center',
    fontSize: 24,
    fontFamily: 'Amiri',
    color: 'rgb(119,156,164)',
  },
  squigglyText: {
    textAlign: 'center',
    fontSize: 42,
    fontFamily: 'Inspiration',
    color: 'rgb(119,156,164)',
  },
  signUpText: {
    marginTop: 15,
    fontFamily: 'Amiri',
    fontSize: 32,
    textAlign: 'center',
    color: 'rgb(119,156,164)',
  },
  disclaimerText: {
    fontSize: 16,
    marginBottom: 30,
    marginTop: 15,
    color: '#aaa'
  },
  nameText: {
    fontSize: 24,
    marginTop: 10,
    color: '#aaa'
  },
  thankYouText: {
    fontSize: 18,
    marginTop: 10,
    color: '#aaa',
    textAlign: 'center',
    margin: 25
  },
  thankYouTextBig: {
    fontSize: 28,
    marginTop: 10,
    color: '#aaa'
  }
}));

function ThankYouPage(props) {
  // console.log('View Online Proposal ', props)
  const [proposal, setProposal] = React.useState({})
  const [logoURL, setLogoURL] = React.useState(null)
  const [contact, setContact] = React.useState({})
  const [pdf, setPDF] = React.useState({})
  const [showESigModal, setShowESigModal] = React.useState(false)

  React.useEffect(() => {

    const fetchEstimate = async (estimateId, contactId) => {
      const response = await axios.get(`${props.url}/api/proposal/getOnlineProposalDetails?estimateId=${estimateId}&contactId=${contactId}`)
      if (response && response.data) {
        // console.log('STUFF: ', response.data)
        setProposal(response.data.estimate)
        setContact(response.data.contact)
        let url = response.data.estimate.entity._id
        let logo = '/' + url + '_Logo_W_BestOfValleyChips.png'
        // <img src="/Logo_W_BestOfValleyCHips.png" />
        // console.log('URL: ', url)
      // console.log('Logo: ', logo)
        setLogoURL(logo)
        let est = response.data.estimate
        if (est && est.url) {
          await axios.get(est.url, {
            withCredentials: false,
            headers: {
              'Content-Type': 'application/octet-stream',
              'Accept': 'application/pdf, application-octet-streatm'
            },
            responseType: 'blob'
          }).then((response) => {
          // }).then(response => response.arrayBuffer())
          //   .then(blob => {
          //   // console.log('Blob: ', blob)
              // let body = response.data
              // let base64Version = Buffer.from(body).toString('base64')
              // console.log('Base 64', base64Version)
              // // let blob = response.data.blob()
              // let newStuff = 'data:application/pdf;base64,' + base64Version
              // console.log(newStuff)
              // console.log('response:', response)
              let newBlob = new Blob([response.data], {type: "application/pdf"})
              // console.log(newBlob)
              const data = window.URL.createObjectURL(newBlob);
              // console.log(data)
              // var link = document.createElement('a');
              // link.href = data;
              // link.download="file.pdf";
              // link.click();
              setPDF(data)
            })
        }
        // setLogoURL(`../../../${url}_Logo.png`)
      }
    }
    // console.log(props.history.match)
    // console.log(props.history.match.params)
    if (props.match && props.match.params && props.match.params.estimateId) {
    // console.log(props.match.params.estimateId)
      if (props.match && props.match.params && props.match.params.contactId) {
        fetchEstimate(props.match.params.estimateId, props.match.params.contactId)
      }
    }
    //  && props.history.match && props.history.match.params && props.history.match.params.estimateId) {
    // // console.log(props.history.match)
    // // console.log(props.history.match.params)
      
    // // console.log('Find estimate ', props.history.match.params.estimateId)
    // }
  }, [props])

  const classes = useStyles();

  function currencyFormat(num) {
    if (!num) num = 0
    return '$' + parseFloat(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }
  return (
    <div className={classes.root}>
     <Paper className={classes.paper}>
        <Grid container>
          
        <Grid item lg={12} xs={12} sm={12} md={12} style={{textAlign: 'center'}}>
          {/* { proposal._id ? <img alt="Logo" src={ logoURL}  style={{ marginTop: '5px', maxHeight: 100, maxWidth: 300}}/> : null } */}
            { proposal._id ? <img alt="Logo" src={ logoURL} className={classes.headerLogo} /> : null }
          </Grid>
          <Grid item lg={12} xs={12} className={classes.headerImages}>
        
            <img src="/OnlineProposalHeaderImage.png" />
            {/* <img src="/Logo_W_BestOfValleyCHips.png" /> */}
          </Grid>

          <Grid item lg={12} xs={12} sm={12} md={12} className={classes.giantText} >
            {/* {(proposal && proposal.entity) ? proposal.entity.name : ''} is excited to propose to you a grand adventure
             */}
            BEAUTIFUL
          </Grid>
          <Grid item lg={12} xs={12} sm={12} md={12} className={classes.subText} >
            {/* {(proposal && proposal.entity) ? proposal.entity.name : ''} is excited to propose to you a grand adventure
             */}
            OUTDOOR LIVING SPACES THAT BENEFIT
          </Grid>
          <Grid item lg={12} xs={12} sm={12} md={12} className={classes.squigglyText} >
            {/* {(proposal && proposal.entity) ? proposal.entity.name : ''} is excited to propose to you a grand adventure
             */}
            The Mind, Body, And Soul
          </Grid>
          <Grid item lg={12} xs={12} sm={12} md={12}  className={classes.nameText}>
             Proposal #{proposal.number} - {proposal.name}
          </Grid>
          <Grid item lg={12} xs={12} sm={12} md={12}  className={classes.thankYouTextBig}>
            Thank You For Your Business!
          </Grid>
          <Grid item lg={12} xs={12} sm={12} md={12}  className={classes.thankYouText}>
        

            You will receive an email shortly with the deposit requirements and payment options.  Once we have received your deposit we will schedule your project in the order it was received.
      
          </Grid>
          <Grid item lg={12} xs={12} sm={12} md={12} className={classes.footerImages}>
            <img src='/OnlineProposalFooterImage.png' width="100%"/>
          </Grid>
          {/* <Grid item lg={12} xs={12} sm={12} md={12} className={classes.disclosureArea}>
            This proposal was intended to be viewed by {(contact && contact._id) ? `${contact.firstName} ${contact.lastName}` : ''}, if you were sent this link inadvertantly please close the browser now.
          </Grid> */}
          <Grid item lg={12} xs={12} sm={12} md={12} className={classes.disclosureArea}>
            Copyright { proposal.entity ? proposal.entity.name : ''} { new Date().getFullYear()}, All Rights Reserved.
          </Grid>
        </Grid>
     </Paper>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    authenticated: state.authenticated,
    notification: state.notification,
    url: state.url
  }
}

export default connect(mapStateToProps)(ThankYouPage)

